import { Mandate } from "creso-core/types";
import { MandateType } from "creso-core/constants";
import { PaginatedResponse } from "../types";
import { api } from "./axios";

export type MandateList = PaginatedResponse<Mandate>;

export const getMandatesApi = (investmentAccountGuid: string) =>
  api.get<MandateList>(`investor-mandates/`, {
    params: {
      investment_account_guid: investmentAccountGuid,
      page_size: 50,
    },
  });

export interface CreateMandatePayload {
  investment_account_guid: string;
  mandate_type: MandateType;
  bank_account_id: string;
  mandate_limit: number;
}

export const createMandateApi = (
  payload: CreateMandatePayload
): Promise<Mandate> =>
  api.post("investor-mandates/", {
    ...payload,
  });

export const deleteMandateApi = (id: number, investmentAccountGuid: string) =>
  api.delete(`investor-mandates/delete/`, {
    data: {
      investment_account_guid: investmentAccountGuid,
      mandate_ids: [id],
    },
  });

export const authorizeMandateApi = (
  id: number,
  investmentAccountGuid: string,
  sendEmail: boolean = false
) =>
  api.post(`investor-mandates/${id}/send_auth_link/`, {
    investment_account_guid: investmentAccountGuid,
    send_email: sendEmail,
  });

export interface MandateAuthResponse {
  id: number;
  firstHolderLink: string;
  secondHolderLink: string;
  thirdHolderLink: string;
}

export const authMandateApi = (
  id: number,
  investmentAccountGuid: string
): Promise<MandateAuthResponse> =>
  api.post(`investor-mandates/${id}/auth/`, {
    investment_account_guid: investmentAccountGuid,
  });

export interface PollMandateStatusResponse {
  message: string;
}

export const pollMandateStatusApi = (
  id: number,
  investmentAccountGuid: string
): Promise<PollMandateStatusResponse> =>
  api.post(`investor-mandates/${id}/poll_status/`, {
    investment_account_guid: investmentAccountGuid,
  });

export const generateMandateStatusReportApi = (investmentAccountGuid: string) =>
  api.post(`mandate-status-report/`, {
    investment_account_guid: investmentAccountGuid,
  });

export const fetchMandateByIdApi = (
  investmentAccountGuid: string,
  id: string | number
): Promise<Mandate> =>
  api.get(`investor-mandates/${id}/`, {
    params: {
      investment_account_guid: investmentAccountGuid,
    },
  });

export const uploadMandateNachFormApi = (data: FormData) =>
  api.post("investor-mandates/upload/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const generatePrefilledNACHMandate = (data: {
  mandateId: number;
  investmentAccountId: string;
}): Promise<{ pdf_url: string; mandate_id: number }> =>
  api.post("investor-mandates/generate/", {
    mandate_id: data.mandateId,
    investment_account_guid: data.investmentAccountId,
  });

export interface EMandateBankCapabilities {
  id: number;
  bank_code: string;
  bank_name: string;
  emandate_netbanking_enabled: boolean;
  emandate_aadhaar_enabled: boolean;
  emandate_debit_card_enabled: boolean;
  payment_netbanking_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export const getBankServiceCapabilitiesByIfscApi = (
  ifscCode: string
): Promise<EMandateBankCapabilities> =>
  api.get("e-mandate-bank-list/by-ifsc/", {
    params: { ifsc_code: ifscCode },
  });
